import type { PaymentMethodDetailsDto } from '@saaga/billingv2-sdk'

import type { BillingPaymentCard } from '@/components/billing/billing.interface'

import { toCardBrand } from './card-brand.util'

export const transformPaymentMethodToCard = (pm: PaymentMethodDetailsDto): BillingPaymentCard => ({
  id: pm.id,
  brand: toCardBrand(pm.brand),
  last4: pm.last4,
  expMonth: pm.expMonth,
  expYear: pm.expYear,
  isDefault: pm.isDefault,
})
